import { Injectable } from "@angular/core";
import { Search } from "./s25.home.search.component";
import { Subject } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class S25qlService {
    private _searchTrigger$ = new Subject();
    public searchTrigger$ = this._searchTrigger$.asObservable();

    triggerSearch(searchData: Search.Params) {
        this._searchTrigger$.next(searchData);
    }
}
